module.exports = __webpack_public_path__ + "static/lifeChat-img2-1669777872b795d53d1530294681d9c9.jpg";